import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { IPagedResult } from '../../shared/models/paged-result';
import { Coupon } from '../../shared/models/sale/coupon';
import { BaseFilterSet } from '../../shared/models/base-filter-set';
import { serialize } from '../../utility/serialize';

const couponApi = createApi({
  reducerPath: 'couponApi',
  baseQuery,
  tagTypes: ['Coupons'],
  endpoints: (builder) => ({
    getCoupons: builder.query<IPagedResult<Coupon>, BaseFilterSet | string | void>({
      query: (filterSet) => {
        let qs = '';
        if (typeof filterSet === 'object') {
          qs = `?${serialize(filterSet)}`;
        } else if (typeof filterSet === 'string') {
          qs = `?${filterSet}`;
        }
        return {
          url: `/api/coupons${qs}`,
          method: 'GET',
        };
      },
      providesTags: ['Coupons'],
    }),
    getCoupon: builder.query<Coupon, string>({
      query: (id) => ({
        url: `/api/coupons/${id}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, id) => [{ type: 'Coupons', id }],
    }),
    createCoupon: builder.mutation<Coupon, Omit<Coupon, 'id'>>({
      query: (body) => ({
        url: '/api/coupons',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Coupons'],
    }),
    updateCoupon: builder.mutation<Coupon, Coupon>({
      query: (body) => ({
        url: `/api/coupons/${body.id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Coupons'],
    }),
    deleteCoupon: builder.mutation<void, string>({
      query: (id) => ({
        url: `/api/coupons/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Coupons'],
    }),
  }),
});

export { couponApi };

export const {
  useGetCouponsQuery,
  useLazyGetCouponsQuery,
  useGetCouponQuery,
  useCreateCouponMutation,
  useUpdateCouponMutation,
  useDeleteCouponMutation,
} = couponApi;
